export function queryToRecord(hashString) {
  return hashString.split('&').reduce((accumulator, item) => {
    const parts = item.split('=');
    accumulator[parts[0]] = parts[1];
    return accumulator;
  }, {});
}
export function containsAll(containerArray, containedArray) {
  return containedArray.every(element => containerArray.includes(element));
}
export function htmlDecode(html) {
  var _doc$documentElement$;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return (_doc$documentElement$ = doc.documentElement.textContent) !== null && _doc$documentElement$ !== void 0 ? _doc$documentElement$ : '';
}
export function containsMarkdownLink(text) {
  if (!text) {
    return false;
  }
  return /\[(.*?)\]\((.*?)\)/.test(text);
}
export function sanitize(string) {
  var _String;
  const reg = /[&<>"'/]/gi;
  return (_String = String(string)) === null || _String === void 0 ? void 0 : _String.trim().replace(reg, '');
}
export function sanitizeSearchBarInput(string) {
  const reg_1 = /[&<>"']/gi;
  const reg_2 = /[ /]/gi;
  return string === null || string === void 0 ? void 0 : string.trim().replace(reg_1, '').replace(reg_2, '_');
}
export function sanitizeStringArray(stringArray) {
  const sanitizedArray = [];
  stringArray === null || stringArray === void 0 ? void 0 : stringArray.forEach(string => {
    sanitizedArray.push(sanitize(string));
  });
  return sanitizedArray;
}